import { createRouter, createWebHashHistory } from 'vue-router'
import { check_permission } from './acl'
import store from '@/store'

import IndexView from '@/views/public/IndexView.vue'
import InfoView from '@/views/public/InfoView.vue'
import InfoGraduate from '@/views/public/InfoGraduate.vue'
import ListUndergraduate from '@/views/public/ListUndergraduate.vue'
import ListGraduate from '@/views/public/ListGraduate.vue'
import LoginView from '@/views/user/LoginView.vue'
import GoogleOAuthHandling from '@/views/user/GoogleOAuthHandling.vue'
import RequestPassword from '@/views/user/RequestPassword.vue'
import MainView from '@/views/prestudent/MainView.vue'
import PageOne from '@/views/prestudent/Page1.vue'
import PageTwo from '@/views/prestudent/Page2.vue'
import PageThreeOne from '@/views/prestudent/Page31.vue'
import PageThreeTwo from '@/views/prestudent/Page32.vue'
import PageFour from '@/views/prestudent/Page4.vue'
import PageFive from '@/views/prestudent/Page5.vue'
import PageSix from '@/views/prestudent/Page6.vue'
import PageSeven from '@/views/prestudent/Page7.vue'
import PageEight from '@/views/prestudent/Page8.vue'
import PageNine from '@/views/prestudent/Page9.vue'
import QuestionView from '@/views/prestudent/QuestionView.vue'
import MainOfficer from '@/views/officer/MainOfficer.vue'
import KmitlOneView from '@/views/student/KmitlOneView.vue'
import ImportData from '@/views/officer/ImportData.vue'
import GenerateStudentID from '@/views/officer/GenStudentID.vue'
import ExportData from '@/views/officer/ExportData.vue'
import FindEdit from '@/views/officer/FindAndEditData.vue'
import ConfigYear from '@/views/configs/ConfigYear.vue'
import ConfigRound from '@/views/configs/ConfigRound.vue'
import ConfigDocument from '@/views/configs/ConfigDocument.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexView
  },
  {
    path: '/info_undergraduate',
    name: 'info_undergraduate',
    component: InfoView
  },
  {
    path: '/info_graduate',
    name: 'info_graduate',
    component: InfoGraduate
  },
  {
    path: '/list_undergraduate',
    name: 'list_undergraduate',
    component: ListUndergraduate
  },
  {
    path: '/list_graduate',
    name: 'list_graduate',
    component: ListGraduate
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/google_oauth_handling',
    name: 'google_oauth_handling',
    component: GoogleOAuthHandling
  },
  {
    path: '/request_password',
    name: 'request_password',
    component: RequestPassword
  },
  {
    path: '/main',
    name: 'main',
    component: MainView
  },
  {
    path: '/page1',
    name: 'page1',
    component: PageOne
  },
  {
    path: '/page2',
    name: 'page2',
    component: PageTwo
  },
  {
    path: '/page31',
    name: 'page31',
    component: PageThreeOne
  },
  {
    path: '/page32',
    name: 'page32',
    component: PageThreeTwo
  },
  {
    path: '/page4',
    name: 'page4',
    component: PageFour
  },
  {
    path: '/page5',
    name: 'page5',
    component: PageFive
  },
  {
    path: '/page6',
    name: 'page6',
    component: PageSix
  },
  {
    path: '/page7',
    name: 'page7',
    component: PageSeven
  },
  {
    path: '/page8',
    name: 'page8',
    component: PageEight
  },
  {
    path: '/page9',
    name: 'page9',
    component: PageNine
  },
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: QuestionView
  },
  {
    path: '/main_officer',
    name: 'main_officer',
    component: MainOfficer
  },
  {
    path: '/kmitl1',
    name: 'kmitl1',
    component: KmitlOneView
  },
  {
    path: '/import_data',
    name: 'import_data',
    component: ImportData
  },
  {
    path: '/generate_studentID',
    name: 'generate_studentID',
    component: GenerateStudentID
  },
  {
    path: '/export_data',
    name: 'export_data',
    component: ExportData
  },
  {
    path: '/find_edit',
    name: 'find_edit',
    component: FindEdit
  },
  {
    path: '/config_year',
    name: 'config_year',
    component: ConfigYear
  },
  {
    path: '/config_round',
    name: 'config_round',
    component: ConfigRound
  },
  {
    path: '/config_document',
    name: 'config_document',
    component: ConfigDocument
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  // รอ API getUserInfo ทำงานเสร็จ
  if (store.state.user.is_authen === null) {
    await new Promise((resolve) => {
      const unwatch = store.watch(
        (state) => state.user.is_authen,
        (newValue) => {
          if (newValue !== null) {
            unwatch();
            resolve();
          }
        }
      );
    });
  }

  // เช็คสิทธิ์การเข้าถึงหน้านั้น ๆ ถ้าไม่มีสิทธิ์ให้ไปหน้า login
  if (!check_permission([to.name])) {
    next('/login');
    return;
  }

  // ถ้าเข้าหน้า login แต่ authen แล้ว ให้ไปหน้า index
  if (to.name === 'login' && store.state.user.is_authen) {
    next('/');
    return;
  }

  next();
});

export default router
